<div class="table-header-area">
  <div class="table-name" i18n>Applications</div>

  <div class="table-controls">
    <app-table-search (filterChanged)="onFilterChanged($event)"></app-table-search>
    <app-buttons
      [isDisabled]="false"
      [name]="btnName"
      [buttonType]="btnMatFlat"
      (buttonClickEvent)="onAddApplication($event)"
      [buttonStyle]="btnStyleFilledSmallForPrimaryBtn"
    >
    </app-buttons>
    <app-buttons
      [isDisabled]="false"
      [name]="versionbtnName"
      [buttonType]="btnMatFlat"
      (buttonClickEvent)="onAddVersionApplication($event)"
      [buttonStyle]="btnStyleFilledSmallForPrimaryBtn"
    >
    </app-buttons>
  </div>
</div>

<app-table
  [displayedColumnLabels]="displayedColumnLabels"
  [displayedColumns]="displayedColumns"
  [dataSource]="dataSource"
  [showCheckbox]="false"
  [showActionButtonsInPagination]="false"
  [showActionColumn]="true"
  [showEditButton]="true"
  [showDeleteButton]="true"
  (editClicked)="onEditApplication($event)"
  (deleteClicked)="openDeleteConfirmationModal($event)"
>
</app-table>
